import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutActions } from '@gestor-web/@core/store/actions';
import { FUNCIONALIDADE } from '@gestor-web/@core/auth/funcionalidades';
import { LayoutSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { GeralService, PermissaoService } from '@gestor-web/app/shared/services';
import { environment } from '@gestor-web/environments/environment';
import { Observable, first } from 'rxjs';

@Component({
    selector: 'bl-page-card-container',
    templateUrl: './page-card-container.component.html',
    styleUrls: ['./page-card-container.component.scss'],
    standalone: false
})
export class PageCardContainerComponent implements OnInit, OnChanges {
  readonly ORIENTACOES_EDIT_URL = `${environment.API_APEX_BASE_PATH}/gestor-idss-admin/orientacao`;
  orientacoesEditUrl: string = this.ORIENTACOES_EDIT_URL;

  @Input()
  backNavigation?: string;

  @Input()
  pageTitle?: string;

  @Input()
  showTooltip?: boolean;

  @Input()
  tooltipKey?: string;

  @Output()
  onCopyUrlFilters = new EventEmitter<void>();

  tooltipHtml: string;
  tooltipUrl: string;

  routeTitle: string;
  podeEditarOrientacoes$: Observable<boolean>;

  suporteVisible$: Observable<boolean>;

  constructor(
    private permissaoService: PermissaoService,
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private geralService: GeralService,
  ) {}

  ngOnInit(): void {
    this.store
      .select(LayoutSelectors.selectPageTitle)
      .pipe(first())
      .subscribe(routeTitle => {
        this.routeTitle = routeTitle;
      });

    this.podeEditarOrientacoes$ = this.permissaoService.checkAcessoFeature(FUNCIONALIDADE.EDITAR_ORIENTACOES);

    this.suporteVisible$ = this.geralService.getConfigSuporteVisible();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.showTooltip && this.tooltipKey) {
      this.tooltipHtml = this.tooltipKey;
      this.geralService.getOrientacao(this.tooltipKey).subscribe({
        next: ({ ds_orientacao, ds_url_documentacao }) => {
          this.tooltipHtml = ds_orientacao;
          this.tooltipUrl = ds_url_documentacao;
          this.orientacoesEditUrl = `${this.ORIENTACOES_EDIT_URL}?p51_cd_orientacao=${encodeURIComponent(
            this.tooltipKey,
          )}`;
        },
        error: _ => {
          this.orientacoesEditUrl = this.ORIENTACOES_EDIT_URL;
        },
      });
    }
  }

  backNavigate() {
    // console.log('[Page] backNavigate', this.backNavigation);
    this.store.dispatch(LayoutActions.toggleFullscreen({ toggle: false }));

    this.router.navigate([this.backNavigation], {
      relativeTo: this.route,
    });
  }
}
